import { render } from "./AdminFormElementButtonRemove.vue?vue&type=template&id=3500c4ee"
import script from "./AdminFormElementButtonRemove.vue?vue&type=script&lang=js"
export * from "./AdminFormElementButtonRemove.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__